export default "__VITE_ASSET__dmPqRCSp__"